import React from "react";
import * as R from "ramda";
import { Link, withRouter } from "react-router-dom";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { css } from "glamor";
import { Dropdown, Menu, Icon, Row, Col, notification } from "antd";

import { switchUser } from "../api/apollo";
import { withApolloState } from "../util/apollo";
import WithAuth from "./WithAuth";

const styles = {
    logo: css({
        maxWidth: "100%",
        maxHeight: "24px",
    }),
    menu: css({
        lineHeight: "64px !important",
        float: "right",
        display: "table", //FIXME - QUICK HACK FOR: T7990
    }),
    dropdownMenu: css({
        textAlign: "right",
    }),
};

const TopBarMenu = ({
    auth,
    permissions,
    menuItems,
    currentLocation,
    users,
    switchUserHandler,
    switchUserBackHandler,
    ...otherProps
}) => {
    const getSelectedItemKeys = R.pipe(
        R.filter(item => R.startsWith(item.link, currentLocation || "")),
        R.map(R.prop("label"))
    );

    return (
        <Menu
            {...otherProps}
            mode="horizontal"
            selectedKeys={getSelectedItemKeys(menuItems)}
        >
            {R.map(
                item => (
                    <Menu.Item key={item.label}>
                        <Link to={item.link}>{item.label}</Link>
                    </Menu.Item>
                ),
                menuItems
            )}

            {permissions && permissions.accessUsermanagement && (
                <Menu.Item>
                    <a href="/usermanagement/">User Management</a>
                </Menu.Item>
            )}

            {auth.is_admin && !auth.switched_from && (
                <Menu.Item>
                    <Dropdown
                        trigger={["click"]}
                        overlay={
                            <Menu>
                                {R.map(
                                    user => (
                                        <Menu.Item
                                            key={user.id}
                                            onClick={() =>
                                                switchUserHandler(user.id)
                                            }
                                        >
                                            {user.username}
                                        </Menu.Item>
                                    ),
                                    users
                                )}
                            </Menu>
                        }
                    >
                        <Link to="#">
                            Switch user
                            <sup>admin only</sup>
                        </Link>
                    </Dropdown>
                </Menu.Item>
            )}

            {auth.switched_from && (
                <Menu.Item onClick={switchUserBackHandler}>
                    Switch back to admin
                </Menu.Item>
            )}

            <Menu.Item>
                <Dropdown
                    overlay={
                        <Menu>
                            {auth.is_admin && (
                                <Menu.Item>
                                    <a href="/beta/entities/">Go to Flow</a>
                                </Menu.Item>
                            )}
                            <Menu.Item>
                                <Link to="/logout/">
                                    <Icon type="logout" /> Logout
                                </Link>
                            </Menu.Item>
                        </Menu>
                    }
                >
                    <Link to="#">{auth.displayName}</Link>
                </Dropdown>
            </Menu.Item>
        </Menu>
    );
};

const TopBarLogo = ({ logo }) => {
    return (
        <Link to="/">
            <img alt="logo" {...styles.logo} src={logo} />
        </Link>
    );
};

class TopBar extends React.Component {
    switchUser = async id => {
        this.handlePreSwitchUser();
        await switchUser(id);
    };

    switchUserBack = async () => {
        this.handlePreSwitchUser();
        await switchUser();
    };

    handlePreSwitchUser = () => {
        notification.open({
            message: "Switching your user ...",
            icon: <Icon type="user" />,
            duration: 2,
        });
    };

    render() {
        return (
            <Query
                fetchPolicy="network-only"
                query={gql`
                    query RequestPortalTopBarQuery {
                        clientConfig {
                            logo
                        }
                        users {
                            id
                            username
                        }
                        permissions {
                            accessUsermanagement
                        }
                    }
                `}
            >
                {withApolloState(({ data }) => (
                    <Row>
                        <Col xs={{ span: 12 }} lg={{ span: 6 }}>
                            <TopBarLogo logo={data.clientConfig.logo} />
                        </Col>

                        <Col xs={{ span: 0 }} lg={{ span: 18 }}>
                            <TopBarMenu
                                menuItems={this.props.menuItems}
                                auth={{ ...this.props.auth }}
                                users={data.users}
                                permissions={data.permissions}
                                switchUserHandler={this.switchUser}
                                switchUserBackHandler={this.switchUserBack}
                                currentLocation={this.props.location.pathname}
                                className={`${styles.menu}`}
                            />
                        </Col>

                        <Col
                            className={`${styles.dropdownMenu}`}
                            xs={{ span: 12 }}
                            lg={{ span: 0 }}
                        >
                            <Dropdown
                                overlay={
                                    <TopBarMenu
                                        menuItems={this.props.menuItems}
                                        auth={{ ...this.props.auth }}
                                        users={data.users}
                                        switchUserHandler={this.switchUser}
                                        switchUserBackHandler={
                                            this.switchUserBack
                                        }
                                    />
                                }
                            >
                                <a href="#">
                                    <Icon type="appstore-o" /> MENU
                                </a>
                            </Dropdown>
                        </Col>
                    </Row>
                ))}
            </Query>
        );
    }
}

export default withRouter(WithAuth(TopBar));
